import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t, language, changeLanguage, availableLanguages } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-black py-16 md:py-20 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <img 
                src="/images/logo.png" 
                alt="ALKA" 
                className="h-10"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <h3 className="text-2xl font-light tracking-[0.3em] text-white hidden">ALKA</h3>
            </div>
            <p className="text-[#A1A1AA] text-sm leading-relaxed max-w-md mb-6">
              {language === 'de' && 'Wir erstellen moderne, schnelle und konversionsstarke Websites für Ihr Unternehmen.'}
              {language === 'en' && 'We create modern, fast, and high-converting websites for your business.'}
              {language === 'tr' && 'İşletmeniz için modern, hızlı ve yüksek dönüşüm sağlayan web siteleri oluşturuyoruz.'}
              {language === 'ru' && 'Мы создаём современные, быстрые сайты с высокой конверсией для вашего бизнеса.'}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-sm font-medium mb-4 tracking-wide">Links</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/impressum"
                  className="text-[#A1A1AA] hover:text-[#B8860B] text-sm transition-colors"
                  data-testid="footer-impressum"
                >
                  {t('footer.impressum')}
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  className="text-[#A1A1AA] hover:text-[#B8860B] text-sm transition-colors"
                  data-testid="footer-datenschutz"
                >
                  {t('footer.datenschutz')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-sm font-medium mb-4 tracking-wide">{t('footer.contact')}</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:info@alka.website"
                  className="text-[#A1A1AA] hover:text-[#B8860B] text-sm transition-colors"
                  data-testid="footer-email"
                >
                  info@alka.website
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          {/* Copyright */}
          <p className="text-[#A1A1AA]/60 text-xs">
            © {currentYear} ALKA. {t('footer.rights')}
          </p>

          {/* Language Switcher */}
          <div className="flex items-center space-x-1 text-xs">
            {availableLanguages.map((lang, idx) => (
              <React.Fragment key={lang}>
                <button
                  onClick={() => changeLanguage(lang)}
                  className={`px-2 py-1 transition-colors ${
                    language === lang
                      ? 'text-[#B8860B]'
                      : 'text-white/40 hover:text-white'
                  }`}
                  data-testid={`footer-lang-${lang}`}
                >
                  {lang.toUpperCase()}
                </button>
                {idx < availableLanguages.length - 1 && (
                  <span className="text-white/20">|</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
